'use client'

import React, { useMemo } from 'react'
import { cn } from '@/utilities/ui'

/**
 * AuroraText – animated gradient text effect.
 * Client island: uses CSS custom properties + animation.
 * Based on Magic UI aurora-text pattern.
 */

interface AuroraTextProps {
  children: React.ReactNode
  className?: string
  colors?: string[]
}

export function AuroraText({ children, className, colors }: AuroraTextProps) {
  const gradientStyle = useMemo(() => {
    const c = colors ?? ['#FF0080', '#7928CA', '#FF0080']
    return {
      backgroundImage: `linear-gradient(90deg, ${c.join(', ')})`,
      backgroundSize: '200% auto',
      WebkitBackgroundClip: 'text',
      WebkitTextFillColor: 'transparent',
      backgroundClip: 'text',
      animation: 'aurora-shift 3s linear infinite',
    } as React.CSSProperties
  }, [colors])

  return (
    <>
      <style
        dangerouslySetInnerHTML={{
          __html: `@keyframes aurora-shift{0%{background-position:0% center}100%{background-position:200% center}}`,
        }}
      />
      <span className={cn('inline', className)} style={gradientStyle}>
        {children}
      </span>
    </>
  )
}
